import { invokeApig } from '../libs/awsLib';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Panel,
  Col,
} from 'react-bootstrap';
import LoaderButton from '../components/LoaderButton';
//import config from '../config.js';
import './NewCustomer.css';

class NewCustomer extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    this.state = {
      isLoading: null,
      customerIndex: '',
      customerSFDCName: '',
      customerSFDCSalesEngineeringActivity: '',
      customerSFDCOpportunityURL: ''
    };
  }

  //Validate OAS customer name
  getIndexValidationState() {
    const length = this.state.customerIndex.length;
    const letterNumber = /^[0-9a-zA-Z]+$/;
    const match = this.state.customerIndex.match(letterNumber);
    if ((length > 0) && (match)) return 'success';
    else if (! match) return 'error';
    else if (length === 0) return 'error';
    return null;
  }

  //Validate SFDC Name
  getSFDCNameValidationState() {
    const length = this.state.customerSFDCName.length;
    const letterNumber = /^[0-9a-zA-Z]+([0-9a-zA-Z- _.,]?)+$/;
    const match = this.state.customerSFDCName.match(letterNumber);
    if ((length > 0) && (match)) return 'success';
    else if (! match) return 'error';
    else if (length === 0) return 'error';
    return null;
  }

  //Validate SE Activity
  getSFDCSalesEngineeringActivityValidationState() {
    const length = this.state.customerSFDCSalesEngineeringActivity.length;
    const letterNumber = /^[a-zA-Z]{2}-[0-9]{0,10}$/;
    const match = this.state.customerSFDCSalesEngineeringActivity.match(letterNumber);
    if ((length > 3) && (match)) return 'success';
    else if (! match) return 'error';
    else if (length < 4) return 'error';
    return null;
  }

  //Validate Opportunity URL
  getSFDCOpportunityURLValidationState() {
    const length = this.state.customerSFDCOpportunityURL.length;
    const webURL = /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
    const match = this.state.customerSFDCOpportunityURL.match(webURL);
    if (match) return 'success';
    else if (length === 0) return null;
    else if (! match) return 'error';
    return null;
  }

  validateForm() {

    //Validate OAS customer name
    if (this.getIndexValidationState() === ('error' || null))
    {   
      // alert("message1");
      return true;
    }

    //Validate SFDC Name
    if (this.getSFDCNameValidationState() === ('error' || null))
    {
      // alert("message2");
      return true;
    }

    //Validate SE Activity
    if (this.getSFDCSalesEngineeringActivityValidationState() === ('error' || null))
    {
      // alert("message3");
      return true;
    }

    //Validate Opportunity URL
    if (this.getSFDCOpportunityURLValidationState() === 'error')
    {
      // alert("message4");
      return true;
    }

    //All form fields check out
    return false;
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });
    try {
      await this.createCustomer({
        customerIndex: this.state.customerIndex,
        customerSFDCName:  this.state.customerSFDCName,
        customerSFDCSalesEngineeringActivity: this.state.customerSFDCSalesEngineeringActivity,
        customerSFDCOpportunityURL: this.state.customerSFDCOpportunityURL
      });
      this.props.history.push('/');
    }
    catch(e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }
  
  async createCustomer(payload) {
    var token = await this.props.getUserToken();
    return invokeApig({
      path: '/customers',
      method: 'POST',
      body: payload,
    }, token);
  }

  render() {
    return (
      <div className="NewCustomer">
      <Col xs={12} md={12} >
        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h2">Create a New Customer</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <h3>Create a new OAS customer account</h3>
            <p>
              This account will be used to identify your customer, upload and process Sysdump files.
            </p>
            <Panel>
              <Panel.Body>
                <form onSubmit={this.handleSubmit}>
                  <FormGroup
                    controlId="customerIndex"
                    validationState={this.getIndexValidationState()}
                  >
                    <ControlLabel>OAS Customer Account Name (Required)</ControlLabel>
                    <FormControl
                      // autoFocus
                      onChange={this.handleChange}
                      value={this.state.customerIndex}
                      placeholder="Enter Text"
                      type="text" />
                    <FormControl.Feedback />
                    <HelpBlock>Can only contain letters and numbers, no spaces or special characters.</HelpBlock>
                  </FormGroup>
                  <FormGroup
                    controlId="customerSFDCName"
                    validationState={this.getSFDCNameValidationState()}
                  >
                    <ControlLabel>Customer Name in SFDC (Required)</ControlLabel>
                    <FormControl
                      onChange={this.handleChange}
                      value={this.state.customerSFDCName}
                      placeholder="Enter Text"
                      type="text" />
                    <FormControl.Feedback />
                    <HelpBlock>Can only contain letters, numbers, spaces and punctuation characters.</HelpBlock>
                  </FormGroup>
                  <FormGroup
                    controlId="customerSFDCSalesEngineeringActivity"
                    validationState={this.getSFDCSalesEngineeringActivityValidationState()}
                  >
                    <ControlLabel>SFDC Sales Engineering Activity (Required)</ControlLabel>
                    <FormControl
                      onChange={this.handleChange}
                      value={this.state.customerSFDCSalesEngineeringActivity}
                      placeholder="Enter text"
                      type="text" />
                    <FormControl.Feedback />
                    <HelpBlock>Starts with two letters and a dash followed by numbers, e.g. "EN-12345". </HelpBlock>
                  </FormGroup>
                  <FormGroup
                    controlId="customerSFDCOpportunityURL"
                    validationState={this.getSFDCOpportunityURLValidationState()}
                  >
                    <ControlLabel>SFDC Opportunity Link (Optional)</ControlLabel>
                    <FormControl
                      onChange={this.handleChange}
                      value={this.state.customerSFDCOpportunityURL}
                      placeholder="Enter URL"
                      type="text" />
                    <FormControl.Feedback />
                    <HelpBlock>Has to be in URL format, e.g. https://riverbed.my.salesforce.com/0012300000w4xYz.</HelpBlock>
                  </FormGroup>
                  <LoaderButton
                    block
                    bsStyle="success"
                    bsSize="large"
                    disabled={ this.validateForm() }
                    type="submit"
                    isLoading={this.state.isLoading}
                    text="Create"
                    loadingText="&nbsp;Creating…" />
                </form>
              </Panel.Body>
            </Panel>
          </Panel.Body>
        </Panel>
      </Col>
      </div>
    );
  }
}

export default withRouter(NewCustomer);


// WEBPACK FOOTER //
// ./src/containers/NewCustomer.js